<template>
  <div class="device_fault_dialog">
    <custom-dialog :visible="visible" width="1200px" :title="model.title" v-on="$listeners">
      <div class="dialog-body">
        <!-- <h1 class="item-title">{{ $t('p_workorderDetail_ljghmx') }}</h1> -->
        <div class="table-dialog-bd">
          <custom-table-expand
            ref="customTb1"
            index
            :rowId="getRowKeys"
            :data="tableList"
            height="500px"
            tableCode="portal_device_fault"
            @sort="sortChange"
            @filter="filterChange"
            @exChange="exChange"
            expand-row-keys
            expand
            :slots="['faultDuration','hmiV4Code','action','expand']"
          >
            <template slot="expand" >
              <div class="expand-content">
                <h3 class="item-title">{{ $t('device_fault_dialog.gzclfa') }}</h3>
                <p>{{ info.hmiDisposal }}</p>
              </div>
            </template>
            <template v-slot:hmiV4Code="scope">
              <div class="msg-content">{{scope.row.hmiV4Code}}{{scope.row.hmiV3Code?'/'+scope.row.hmiV3Code:''}}</div>
            </template>
            <template v-slot:faultDuration="scope">
              <div class="msg-content">{{$minToHour(scope.row.faultDuration)||'-'}} h</div>
            </template>
            <template v-slot:action="scope">
              <el-button
                type="text"
                size="mini"
                v-if="funcView.portal_device_faultRemoval"
                @click="onCloseFault(scope.row)"
              >{{ $t('device_fault_dialog.ren_gong_jie_chu') }}</el-button>
            </template>
          </custom-table-expand>
        </div>
        <div class="page-footer" >
          <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import customTableExpand from '@/components/customTableExpand.vue';

export default {
  mixins: [dialogMixins],
  components: {
    customTableExpand,
  },
  data() {
    return {
      tableCode: 'portal_device_fault',
      // 获取row的key值
      getRowKeys(row) {
        return row.faultInfoId;
      },
      info: {},
      bodyNum: '',
      tableList: [],
      totalRows: null,

      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
        dataType: '1',
        bodyNum: ''
      },
    };
  },
  mounted() {
    this.getFuncView('/other/device', () => {
      this.initDialog();
    });
  },

  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.model.type === 'detail') {
        this.formSearch.bodyNum = this.model.data.bodyNum;
        // this.bodyNum = '20200509006';
        this.getTableList();
      }
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.faultInfoPage, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();

    },
    exChange: function (row) {
      this.getFaultInfoDetail(row);
    },
    // 获取故障详情
    getFaultInfoDetail: async function (item) {
      if (!item.faultInfoId) {
        return;
      }
      this.$getJSON(apis.faultInfoDetail, { faultInfoId: item.faultInfoId }, true).then((res) => {
        this.info = res.data;
      });
    },

    onCloseFault(row) {
      const { faultInfoId } = row;
      this.$showConfirm(this, this.$t('device_fault_dialog.nqdyrgjcxzdgzm')).then(() => {
        this.$postJSON(`${apis.faultClearFault}/${faultInfoId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success')
          });
          this.getTableList();
        });
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },


  },
};
</script>

<style lang="scss">
.device_fault_dialog {
  .item-title {
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
  line-height: 22px;
  font-size: 14px;
  margin-bottom: 16px;
  position: relative;
  padding-left: 10px;
  &:after {
    content: '';
    position: absolute;
    width: 4px;
    height: 15px;
    background: rgba(0, 175, 255, 1);
    left: 0px;
    top: 4px;
  }
}
}
</style>
